/**
 * [INPUT]: 依赖 framer-motion 与 ./motion 语义令牌，消费数据条最终宽度及用户减弱动效偏好
 * [OUTPUT]: 对外提供 ChartReveal、AnimatedMeter 两个后台数据动画原语
 * [POS]: zinnercms-design-system/motion 的 React 数据语义层；世界地图/热力图等非 dither 可视化整体淡入，数据条以裁切掩膜生长避免挤压内容
 * [PROTOCOL]: 变更时更新此头部，然后检查 CLAUDE.md
 */
import { m as Motion, useReducedMotion } from 'framer-motion'

import { TRANSITION, VARIANTS } from './motion'

function ChartReveal({ className, children, ...props }) {
  return (
    <Motion.div
      data-slot="chart-reveal"
      className={className}
      initial="initial"
      animate="animate"
      variants={VARIANTS.chart}
      transition={TRANSITION.chartReveal}
      {...props}
    >
      {children}
    </Motion.div>
  )
}

function AnimatedMeter({ className, children, style, ...props }) {
  const shouldReduceMotion = useReducedMotion()

  return (
    <Motion.div
      data-slot="animated-meter"
      className={className}
      data-motion-mode={shouldReduceMotion ? 'reduced' : 'active'}
      initial={{
        clipPath: shouldReduceMotion ? 'inset(0 35% 0 0)' : 'inset(0 100% 0 0)',
        opacity: shouldReduceMotion ? 0.9 : 0.72,
      }}
      animate={{ clipPath: 'inset(0 0% 0 0)', opacity: 1 }}
      transition={shouldReduceMotion ? TRANSITION.meterReduced : TRANSITION.meter}
      style={style}
      {...props}
    >
      {children}
    </Motion.div>
  )
}

export { AnimatedMeter, ChartReveal }
